// actions
import * as actions from './actions';

const initialState = {
  groups: [],
  available: true,
  flowers: [],
  questions: [],
  reading: null,
  readingEvaluated: false,
  leadCaptured: false,
  error: null,
  submitError: null,
  loading: false,
  initial: false,
  checkoutLoading: false,
  purchaseVerified: false,
  fullReading: null,
  emailAccess: false,
  emailAccessExpires: null,
};

export default function bachFlowersReducer(state = initialState, action) {
  switch (action.type) {
    // Groups
    case actions.FETCH_BACH_GROUPS_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_BACH_GROUPS_SUCCESS:
      return { ...state, groups: action.payload.groups, available: action.payload.available, loading: false, initial: true, error: null };

    case actions.FETCH_BACH_GROUPS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Questionnaire
    case actions.FETCH_QUESTIONNAIRE_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_QUESTIONNAIRE_SUCCESS:
      return { ...state, questions: action.payload.questions, loading: false, error: null };

    case actions.FETCH_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Submit
    case actions.SUBMIT_QUESTIONNAIRE_REQUEST:
      return { ...state, loading: true, submitError: null, reading: null };

    case actions.SUBMIT_QUESTIONNAIRE_SUCCESS:
      return { ...state, reading: action.payload.reading, loading: false, submitError: null };

    case actions.SUBMIT_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, submitError: action.payload };

    // All flowers (catalog)
    case actions.FETCH_BACH_ALL_FLOWERS_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_BACH_ALL_FLOWERS_SUCCESS:
      return { ...state, flowers: action.payload.flowers, loading: false, error: null };

    case actions.FETCH_BACH_ALL_FLOWERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Like
    case actions.SET_BACH_READING_LIKE_REQUEST:
      return { ...state };

    case actions.SET_BACH_READING_LIKE_SUCCESS:
      return { ...state, readingEvaluated: true };

    case actions.SET_BACH_READING_LIKE_FAILURE:
      return { ...state };

    // Capture lead
    case actions.CAPTURE_BACH_LEAD_REQUEST:
      return { ...state };

    case actions.CAPTURE_BACH_LEAD_SUCCESS:
      return { ...state, leadCaptured: true };

    case actions.CAPTURE_BACH_LEAD_FAILURE:
      return { ...state };

    // Checkout (Stripe)
    case actions.CREATE_BACH_CHECKOUT_REQUEST:
      return { ...state, checkoutLoading: true, error: null };

    case actions.CREATE_BACH_CHECKOUT_SUCCESS:
      return { ...state, checkoutLoading: false };

    case actions.CREATE_BACH_CHECKOUT_FAILURE:
      return { ...state, checkoutLoading: false, error: action.payload };

    // Checkout (PayPal)
    case actions.CREATE_BACH_PAYPAL_ORDER_REQUEST:
      return { ...state, checkoutLoading: true, error: null };

    case actions.CREATE_BACH_PAYPAL_ORDER_SUCCESS:
      return { ...state, checkoutLoading: false };

    case actions.CREATE_BACH_PAYPAL_ORDER_FAILURE:
      return { ...state, checkoutLoading: false, error: action.payload };

    // Verify purchase (Stripe)
    case actions.VERIFY_BACH_PURCHASE_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.VERIFY_BACH_PURCHASE_SUCCESS:
      return { ...state, loading: false, purchaseVerified: true, fullReading: action.payload.reading };

    case actions.VERIFY_BACH_PURCHASE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Verify purchase (PayPal)
    case actions.VERIFY_BACH_PAYPAL_PURCHASE_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.VERIFY_BACH_PAYPAL_PURCHASE_SUCCESS:
      return { ...state, loading: false, purchaseVerified: true, fullReading: action.payload.reading };

    case actions.VERIFY_BACH_PAYPAL_PURCHASE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Check access
    case actions.CHECK_BACH_ACCESS_REQUEST:
      return { ...state };

    case actions.CHECK_BACH_ACCESS_SUCCESS:
      return {
        ...state,
        emailAccess: action.payload.hasAccess,
        emailAccessExpires: action.payload.expiresAt,
        purchaseVerified: action.payload.hasAccess ? true : state.purchaseVerified,
      };

    case actions.CHECK_BACH_ACCESS_FAILURE:
      return { ...state };

    // Reset
    case actions.RESET_BACH_FLOWERS:
      return { ...initialState };

    default:
      return state;
  }
}
